const DEBUG = true;
const logger = {
  info(message, payload) {
    if (typeof window === "undefined") return;
    if (window.__ZIGGY_DEBUG__ !== true) return;
    if (!DEBUG) return;
    console.info(`[ZiggyDropdown] ${message}`, payload ?? "");
  },
};

class ZiggyDropdown extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
  }

  connectedCallback() {
    this.trigger = this.querySelector(".dropdown-trigger");
    this.panel = this.querySelector(".dropdown-panel");
    this.icon = this.querySelector(".dropdown-icon");

    if (!this.trigger || !this.panel) return;

    this.trigger.addEventListener("click", this.toggle.bind(this));
    document.addEventListener("click", this.handleClickOutside.bind(this));
    document.addEventListener("keydown", this.handleKeydown.bind(this));
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.update();
  }

  open() {
    this.isOpen = true;
    this.update();
  }

  close() {
    this.isOpen = false;
    this.update();
  }

  update() {
    this.trigger.setAttribute("aria-expanded", this.isOpen);
    this.dataset.open = this.isOpen;

    this.icon.classList.toggle("rotate-180", this.isOpen);
  }

  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener("keydown", this.handleKeydown);
  }
}

if (!customElements.get("ziggy-dropdown")) {
  customElements.define("ziggy-dropdown", ZiggyDropdown);
}
